class TokenFormCtrl {
  constructor(TemplateService, EventService, AuthService) {
    'ngInject';
    this.modalTitle = '';
    this.ts = TemplateService;
    this.es = EventService;
    this.as = AuthService;
  }
  
  async $onInit() {
    const td = await this.ts.getTemplateData();
    const PROVIDER = await this.as.getProviderSettings(td.template);
    const ref = td.template.references.find(r => r.id === this.token.referenceId);
    this.field = this.token.fieldSchema;
    this.modalTitle = `${this.field.label} (${ref.name})`;
    if (this.token.options?.choice?.display) 
      this.modalTitle += ` - Choice: [${this.token.options?.choice?.display}]`;
    
    this.providerLink = {
      text: `Open "${this.token.fieldSchema.label}" in ${PROVIDER.name}`,
      url: PROVIDER.fieldLinkTemplate
        .replace('[REALM]', td.template.realm)
        .replace('[TABLE_ID]', ref.tableId)
        .replace('[FIELD_ID]', this.token.fieldId)
    };
  }
  
  removeToken(token) {
    this.es.dispatchEvent(this.es.actions.TOKEN_REMOVE, {token, closeModal: true});
  }

}

export default {
  bindings: {
    token: "=",
    style: "=",
    reportOptions: "=",
    invalidCss: "=",
    section: "=",
    onUpdate: "&",
    onCancel: "&"
  },
  templateUrl: "form-builder/forms/token-form/token-form.component.html",
  controller: TokenFormCtrl
};